/**
 * ruts-vh-home-carousel-tap-fix.js
 *
 * Responsabilidad unica: en la home movil, las product-card estan anidadas
 * dentro de un <slideshow-component> (carrusel nativo de Horizon,
 * layout_type: "carousel"). Su listener de arrastre (#handleMouseDown, en
 * assets/slideshow.js) llama a event.preventDefault() en CUALQUIER
 * mousedown dentro del carrusel, incluido el mousedown sintetico que los
 * navegadores moviles generan tras un tap. Eso puede suprimir el click
 * sintetico posterior, y con el los swatches de Variant Hero (.sk-cs)
 * nunca reciben el evento click del que dependen para cambiar la imagen.
 *
 * Este script no toca Variant Hero, no toca el carrusel, no anade
 * preventDefault ni bloqueos de clic: unicamente detiene la propagacion
 * del mousedown en el propio swatch, antes de que llegue al listener del
 * carrusel. El clic en si sigue su curso nativo sin cambios.
 *
 * Incluido solo en index (home). No afecta collection, search, PDP,
 * carrito ni escritorio.
 */
(function () {
  'use strict';

  var main = document.querySelector('main');
  if (!main) return;

  function stopBeforeCarousel(event) {
    event.stopPropagation();
  }

  function wireSwatch(sk) {
    if (!sk || sk.dataset.rutsTapFixWired === 'true') return;
    if (!sk.closest('slideshow-component')) return;
    sk.dataset.rutsTapFixWired = 'true';
    sk.addEventListener('mousedown', stopBeforeCarousel);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    var nodes = root.matches && root.matches('.sk-cs') ? [root] : root.querySelectorAll('.sk-cs');
    for (var i = 0; i < nodes.length; i++) {
      wireSwatch(nodes[i]);
    }
  }

  scan(main);

  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var addedNodes = mutations[m].addedNodes;
      for (var n = 0; n < addedNodes.length; n++) {
        var node = addedNodes[n];
        if (node.nodeType === 1) {
          scan(node);
        }
      }
    }
  });

  observer.observe(main, { childList: true, subtree: true });
})();
